import { useEffect, useState } from 'react';
import { publicNewsApi } from '@/features/publicsite/news/api/publicNewsApi';

/** The categories /stiri's category filter offers — empty until they arrive, or if they fail. */
export function useNewsCategories(): string[] {
  const [categories, setCategories] = useState<string[]>([]);

  // Once: the categories do not change with the filters, and asking again per filter would shrink
  // the choice to whatever the current filter already left.
  useEffect(() => {
    publicNewsApi
      .categories()
      .then(setCategories)
      .catch(() => undefined);
  }, []);

  return categories;
}
